/**
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
/**
 * Date         : 2021-06-17 11:19:44
 * description  : 描述
 * author       : zhizhan
 */
import "./index.less";
import React from "react";
import YxIcon from "../YxIcon";
import { get, yxStyleProps } from "../../../../utils";
import { YxComponent, Connection } from "../../../YxComponent";

/**
 * @param {any} iconfont 是否显示icon
 */

const defaultProps = function () {
  return {
    onClick: (event) => event.preventDefault(),
    styleParam: {
      type: "default",
    },
    disabled: false,
    icon: null,
  };
};

@Connection(defaultProps)
class YxLink extends YxComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: false,
      disabled: false,
    };
  }

  renderIcon = () => {
    const icon = get(this.props, "icon", null);
    if (icon != null) {
      const param = {
        type: icon,
        iconfont: get(this.props, "iconfont", false),
        ...get(this.props, "iconParam", {}),
      };
      return <YxIcon {...yxStyleProps(param, "iconParam")} />;
    }
    return null;
  };

  get disabled() {
    const statusList = [
      get(this.props, ["disabled", "loading"], true),
      get(this.state, ["disabled", "loading"], true),
    ];
    return statusList.some((item) => item === true);
  }

  get className() {
    const classDict = {
      yx_yxLink_: "styleParam.type",
    };
    const result = this.styleParamClassName(this.props, classDict);
    return (
      result +
      (get(this.props, "icon", null) != null ? " yx_action_link_icon" : "")
    );
  }

  onClick = (event) => {
    if (this.props.href == null) {
      event.preventDefault();
    }
    get(this.props, "onClick", () => {})(event);
  };

  render() {
    return (
      <a
        {...yxStyleProps(this.props, "iconfont", "loading", "iconParam")}
        onClick={this.onClick}
        disabled={this.disabled}
        className={this.className}
      >
        {this.props.children}
        {this.renderIcon()}
      </a>
    );
  }
}

export default YxLink;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxAction/components/YxLink/index.js